import React from "react";
import { bool, string, number } from "prop-types";
import { connect, useDispatch } from "react-redux";
import { compose } from "redux";
import { goBack } from "connected-react-router";
import { withRouter } from "react-router-dom";
import withExchangeToken from "pages/_components/withExchangeToken";
import { resizableRoute } from "pages/_components/Resizable";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import Credential from "pages/_components/fields/credentials/Credential";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import CustomText from "pages/_components/CustomText/CustomText";
import { Mixpanel } from "util/clickstreaming";
import * as i18n from "util/i18n";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { ResponsiveHeader } from "pages/_components/header";
import Stepper from "../../onboarding/_components/Stepper";

const PAGE_ID = "StepVerifyPassword";

const FORM_ID = "login.step2";

const StepVerifyPassword = ({ isMobile, securitySeal, securitySealAlt, fetching, onboardingWithEnrolledUser }) => {
    const dispatch = useDispatch();

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    return (
        <>
            <Notification scopeToShow="login" />
            {isMobile && (
                <ResponsiveHeader
                    ticket
                    id={i18n.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                    onClickBack={isMobile && onHeaderBack}
                />
            )}
            <MainContainer>
                {!isMobile && (
                    <Head
                        title={i18n.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                        onBack={isMobile && onHeaderBack}
                    />
                )}
                <Notification scopeToShow="login" />
                <Stepper isMobile={isMobile} page={PAGE_ID} />
                <Form className="login-desktop-wrapper container--layout">
                    <h1>
                        <CustomText textType="TEXT" keepSpaceIfNoText text={i18n.get("", "Validá tus credenciales")} />
                    </h1>
                    <CustomText
                        text={i18n.get("onboarding.enrolled.user.security.image", "¿Esta es tu imagen de seguridad?")}
                    />
                    <div className="text-lead security-image">
                        <div id="figureId" className="img">
                            <figure>
                                <img src={securitySeal} alt={i18n.get(securitySealAlt)} />
                            </figure>
                        </div>
                        <p id="verifyImage">
                            <I18n id="login.step2.verifyYourImage" />
                        </p>
                    </div>
                    <Field
                        idForm={FORM_ID}
                        name="password"
                        copyEnabled={false}
                        component={Credential}
                        autoFocus
                        hidePlaceholder
                    />
                    <div className="form-group mb-8">
                        <Button type="submit" bsStyle="primary" label="global.continue" loading={fetching} />
                    </div>
                </Form>
            </MainContainer>
        </>
    );
};

StepVerifyPassword.propTypes = {
    isMobile: bool.isRequired,
    securitySeal: number.isRequired,
    securitySealAlt: string.isRequired,
    fetching: bool.isRequired,
    onboardingWithEnrolledUser: bool.isRequired,
};

const mapStateToProps = (state) => ({
    securitySeal: onboardingSelectors.getSecuritySeal(state),
    securitySealAlt: onboardingSelectors.getSecuritySealAlt(state),
    username: onboardingSelectors.getUsername(state),
    onboardingWithEnrolledUser: onboardingSelectors.getOnboardingWithEnrolledUser(state),
    fetching: onboardingSelectors.getFetching(state),
});

export default compose(
    withRouter,
    connect(mapStateToProps),
    resizableRoute,
    withFormik({
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: () => ({
            password: "",
            captcha: "",
        }),
        validationSchema: () =>
            Yup.object().shape({
                password: Yup.string().required(i18n.get(`${FORM_ID}.password.required`)),
            }),
        handleSubmit: ({ password }, formikBag) => {
            const { props } = formikBag;
            const { username } = props;
            formikBag.props.dispatch(onboardingActions.verifyUserCredentialsStep2Migration(username, password));
            Mixpanel.track(FORM_ID);
        },
    }),
)(withExchangeToken(StepVerifyPassword));
